export default __webpack_public_path__ + "static/media/configurationIcon.ad90a65c.svg";